import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SearchMainComponentSelectorComponent} from './components/search-main-component-selector/search-main-component-selector.component';

const routes: Routes = [
  {
    path: '',
    component: SearchMainComponentSelectorComponent,
    data: {layout: {narrowMainContainer: true, greyBackground: true}},
  },
  {
    path: ':urlPath1',
    component: SearchMainComponentSelectorComponent,
    data: {layout: {narrowMainContainer: true, greyBackground: true}},
  },
  {
    path: ':urlPath1/:urlPath2',
    component: SearchMainComponentSelectorComponent,
    data: {layout: {narrowMainContainer: true, greyBackground: true}},
  },
  {
    path: ':urlPath1/:urlPath2/:urlPath3',
    component: SearchMainComponentSelectorComponent,
    data: {layout: {narrowMainContainer: true, greyBackground: true}},
  },
  {
    path: ':urlPath1/:urlPath2/:urlPath3/:urlPath4',
    component: SearchMainComponentSelectorComponent,
    data: {layout: {narrowMainContainer: true, greyBackground: true}},
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SearchRoutingModule {}

export const searchRoutingComponents = [SearchMainComponentSelectorComponent];
